import React, {useEffect, useRef, useState} from 'react';
import useModal from "components/modal/useModal";
import useFetchData from "hooks/useFetchData";
import {Logout} from "assets/icons";
import {NavLink, useNavigate} from "react-router-dom";
import DropdownMenu from "components/DropdownMenu/DropdownMenu";

const LogoutNavDesktop = () => {
    const {userData} = useFetchData()
    const {toggle} = useModal();
    const navigate = useNavigate();
    const pRole = localStorage.getItem('rUser')
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    
    // Fermer le dropdown quand on clique ailleurs
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);
    
    // Fonction pour obtenir les initiales
    const getInitials = () => {
        const firstname = userData?.firstname || '';
        const lastname = userData?.lastname || '';
        const firstInitial = firstname.charAt(0).toUpperCase();
        const lastInitial = lastname.charAt(0).toUpperCase();
        const initials = (firstInitial + lastInitial).trim()
        return initials || '--';
    };
    
    // Fonction pour mapper le rôle
    const getRoleName = () => {
        const tRole = {
            '200': 'Observateur',
            '205': 'Manageur',
            '210': 'Responsable',
            '215': 'Directeur',
            '220': 'Superviseur',
            '225': 'Administrateur'
        };
        return tRole[pRole] || 'Utilisateur';
    };
    
    const handleLogout = (e) => {
        e.preventDefault();
        toggle('log_d_logout');
    };

    const handleProfil = (e) => {
        e.preventDefault();
        navigate('/personalInformations/myPersonalAccount');
        setIsOpen(false);
    };

    const handleAdmin = (e) => {
        e.preventDefault();
        navigate('/adminCompany');
        setIsOpen(false);
    };
    
    const dropdownItems = [
        {
            label: 'Mon profil',
            onClick: handleProfil
        }
    ];

    if (pRole === '225') {
        dropdownItems.push({
            label: 'Console d\'administration',
            onClick: handleAdmin
        });
    }

    dropdownItems.push({
        separator: true
    });

    dropdownItems.push({
        icon: Logout,
        label: 'Se déconnecter',
        onClick: handleLogout,
        iconColor: '#EF4444',
        className: 'text-red-500'
    });
    
    return (
        <>
            <div 
                ref={dropdownRef}
                className="group relative flex items-center gap-3 cursor-pointer hover:bg-gray-100 rounded-lg px-2 py-1 transition-colors"
                onClick={() => setIsOpen(!isOpen)}
            >
                {/* Initiales */}
                <div className="min-w-[40px] w-[40px] h-[40px] rounded-full bg-gray-100 group-hover:bg-gray-200 flex items-center justify-center transition-colors">
                    <span className="text-sm font-medium text-gray-700">
                        {getInitials()}
                    </span>
                </div>
                {/* Informations utilisateur */}
                <div className="flex flex-col min-w-[120px]">
                    <span className="text-sm font-medium text-gray-700 leading-5 h-5">
                        {`${userData?.firstname || ''} ${userData?.lastname || ''}`.trim() || '\u00A0'}
                    </span>
                    <span className="text-xs text-gray-500 leading-4 h-4">
                        {getRoleName()}
                    </span>
                </div>
                
                {/* Dropdown menu */}
                {isOpen && (
                    <div className="absolute top-full right-0 mt-2 w-56 z-50">
                        <DropdownMenu items={dropdownItems} width="w-56" />
                    </div>
                )}
            </div>
        </>
    );
};

export default LogoutNavDesktop;